import dashboard from "@/views/dashboard/index";

export default [
  {
    path: "/material",
    name: "material",
    component: dashboard,
    redirect: {
      name: "materialIndex"
    },
    children: [
      {
        path: "materialIndex",
        name: "materialIndex",
        meta: { title: "物料着陆页设置" },
        component: () => import("@/views/material/baseDataMaterial.vue"),
        children: [
          {
            path: "editMaterialInfo/:materialId",
            name: "editMaterialInfo",
            meta: { title: "编辑物料着陆页" },
            component: () => import("@/views/material/materialManage.vue")
          },
          {
            path: "addMaterialInfo",
            name: "addMaterialInfo",
            meta: { title: "添加物料着陆页" },
            component: () => import("@/views/material/addMaterial.vue")
          }
        ]
      }
    ]
  }
];
